import { Typography } from '@mui/material';
import React from 'react';
import { formatDuration } from '../utils';

type EpisodeDurationProps = {
  durationMillis?: number;
};

const EpisodeDuration: React.FC<EpisodeDurationProps> = ({
  durationMillis = 0,
}) => <Typography variant="body1">{formatDuration(durationMillis)}</Typography>;
export default EpisodeDuration;
